module.exports = __webpack_public_path__ + "img/happy-landlords.0a2369c8.png";